export default __webpack_public_path__ + "static/media/hig-popup.0bfbf96c.webp";